import { computed } from 'vue'
// types
import type { UseAppIconOptions, UseAppIconReturn } from '../types/interfaces'
import type { ResponsiveProp } from '../types/types'

function resolveResponsiveProp<T extends string> (
  prop: ResponsiveProp<T> | undefined,
  defaultValue?: T,
): Record<string, T> {
  if (prop === undefined) {
    return defaultValue !== undefined ? { base: defaultValue } : {}
  }
  if (typeof prop === 'string') {
    return { base: prop }
  }
  return prop as Record<string, T>
}

function generateClassNames (
  resolved: Record<string, string>,
  prefix: string,
): string[] {
  const classes: string[] = []
  for (const [bp, value] of Object.entries(resolved)) {
    classes.push(bp === 'base'
      ? `app-icon--${prefix}${value}`
      : `app-icon--${bp}-${prefix}${value}`)
  }
  return classes
}

export function useAppIcon (options: UseAppIconOptions): UseAppIconReturn {
  const { props } = options

  const classList = computed<string[]>(() => {
    const classes: string[] = ['app-icon']

    const size = resolveResponsiveProp(props.size, 'big')
    classes.push(...generateClassNames(size, ''))

    const color = resolveResponsiveProp(props.color)
    if (Object.keys(color).length > 0) {
      classes.push(...generateClassNames(color, 'color-'))
    }

    return classes
  })

  return { classList }
}
